import ChatList from './styled';

export default ChatList;
